<div id="<%= dom_id heat %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Dance:</strong>
    <%= heat.dance_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Entry:</strong>
    <%= heat.entry_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Number:</strong>
    <%= heat.number %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Ballroom:</strong>
    <%= heat.ballroom %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Category:</strong>
    <%= heat.category %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Prev number:</strong>
    <%= heat.prev_number %>
  </div>
</div>
